import cn from 'classnames';
import React, { type ReactEventHandler } from 'react';
import {
  popupClassNames,
  popupClassNamesMobile,
} from '../Payment3dsPopup/Payment3dsPopup';
import styles from '../Payment3dsPopup/payment3dsPopup.module.css';
import Popup from '../Popup';

type Props = {
  isPopupOpened: boolean;
  isMobile: boolean;
  onClose: () => void;
  onSuccess: () => void;
  url?: string;
};

const IFRAME_NAME = 'pay2meIframe';

const Pay2MePopup = (props: Props) => {
  const { isPopupOpened, onClose, url, isMobile, onSuccess } = props;

  /**
   * onLoad срабатывает на загрузку страницы в айфрейме
   * Когда оплата проходит успешно, pay2me открывает новую страницу (срабатывает onLoad)
   * и проставляет платежные ответы в поле LT_Payment3dsData, поэтому
   * только после этого вызываем функции успешного завершения оплаты
   */
  const onLoad: ReactEventHandler<HTMLIFrameElement> = (e) => {
    try {
      // @ts-ignore
      if (e.target.contentWindow.LT_Payment3dsData) {
        onClose();
        onSuccess();
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  };

  if (!isPopupOpened || !url) return null;
  return (
    <Popup
      open={isPopupOpened}
      onClose={onClose}
      showCloseIcon={false}
      classNames={isMobile ? popupClassNamesMobile : popupClassNames}
    >
      <iframe
        title="pay2me payment"
        name={IFRAME_NAME}
        onLoad={onLoad}
        className={cn(styles.iframeDesktop, {
          [styles.iframeMobile]: isMobile,
        })}
        src={url}
      />
    </Popup>
  );
};

export default Pay2MePopup;
